export default __webpack_public_path__ + "static/media/stone_guy_timesquare.99dabebf.jpg";